import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'ac0062',
    ecrans: ['00-2'],
    params:['id', '?foucleint']
});